import React, { useState, useEffect } from 'react';
import MarkdownRenderer from '../components/MarkdownRenderer';
import LoadingState from '../components/LoadingState';

/**
 * Standalone About page component
 * Extracted from ContentViewer.js
 */
function AboutPage() {
  const [aboutContent, setAboutContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load about.md file
    fetch('/about.md')
      .then(response => response.text())
      .then(text => {
        // Extract content after frontmatter
        const frontmatterEnd = text.indexOf('---', 3);
        const content = frontmatterEnd > 0 ? text.substring(frontmatterEnd + 3).trim() : text;
        setAboutContent(content);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load about content:', err);
        setAboutContent('# About Sutra\n\nA modern static site generator.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="welcome-page">
        <div className="welcome-content">
          <LoadingState />
        </div>
      </div>
    );
  }

  return (
    <div className="welcome-page">
      <div className="welcome-content prose">
        <MarkdownRenderer content={aboutContent} />
      </div>
    </div>
  );
}

export default AboutPage;
